import Head from 'next/head'
import React from 'react'
import { useRouter } from 'next/router'

export const SEOTitle = ({ title }: { title: string }) => {
    const router = useRouter()
    const getTitle = () => {
        if (router.locale === 'ar') {
            return (
                // eslint-disable-next-line i18next/no-literal-string
                <title style={{ direction: 'rtl' }}>
                    الشرق الأوسط OOKA |{`  ${title}`}
                </title>
            )
        }
        return (
            <title style={{ direction: 'rtl' }}>{`${title} | OOKA ME`}</title>
        )
    }

    return <Head>{getTitle()}</Head>
}
